<div class="billing-container">
<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-3">
      <h4 class="title"><i class="fa fa-code-branch"></i> Servicios de facturación</h4>
    </div>
    <div class="col-md-2 mt-3 content-position-end">
      <button type="button"
              class="btn btn-outline-success mw-180 font-weight-bold custom-button"
              *ngIf="hasRole(ROLE_SUPERADMIN)"
              (click)="createBillingServices()">
        <i class="fa fa-plus"></i> {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
</div>

<div class="row align-billing">
  <div class="col-md-3" *ngIf="hasRole(ROLE_SUPERADMIN)">
    <label class="font-weight-bold">
      {{ "LABEL.PARTNER" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
      </div>
      <select *ngIf="hasRole(ROLE_SUPERADMIN)"
              class="form-control  mr-2"
              [(ngModel)]="partnerSelected"
              (ngModelChange)="reloadBillingServices()">
        <option *ngFor="let partner of partners" [ngValue]="partner">{{ partner.name }}</option>
      </select>
    </div>
  </div>
  <div class="col-md-3" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
    <label class="font-weight-bold">
      {{ "LABEL.ENTERPRISE" | translate }}:</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
      </div>
      <select *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)"
              class="form-control mr-2"
              [(ngModel)]="enterpriseSelected"
              (ngModelChange)="reloadBillingServices0()">>
        <option *ngFor="let enterprise of enterprises"
                [ngValue]="enterprise">{{ enterprise.name | translate }}
        </option>
      </select>
    </div>
  </div>
  <div class="col-md-3">
    <label class="font-weight-bold">
      Refrescar:</label>
    <div class="input-group">
      <button type="button"
              class="btn btn-outline-success mw-180 font-weight-bold custom-button mr-2"
              (click)="loadBillingServices()">
        <i class="fa fa-sync-alt"></i> Refrescar
      </button>
    </div>
  </div>
</div>

<div *ngIf="billingservices?.length > 0; else noData" class="billing-container1">
  <div *ngFor="let service of billingservices" class="billing-card">
    <h3>{{ service.description }}</h3>
    <p class="credit">Asignado: {{ service.assignedCredit }}</p>
    <p class="credit">Saldo: {{ service.currentCredit }}</p>
    <span class="status" [ngClass]="service.disabled ? 'disabled' : 'active'">
      {{ service.disabled ? 'Agotado' : 'Disponible' }}
    </span>
    <span class="status" [ngClass]="service.active ? 'active' : 'disabled'">
      {{ service.active ? 'Activo' : 'Inactivo' }}
    </span>
  </div>
</div>
</div>
<ng-template #noData>
  <p class="no-data">No hay servicios de facturación disponibles.</p>
</ng-template>
<app-loading *ngIf="loading"></app-loading>
